import { init as initSDK, FullStory as FS } from '@fullstory/browser';
import { ENVIRONMENTS } from './constants/environment.constants';
const { PRODUCTION: PRODUCTION_ENV } = ENVIRONMENTS;
/**
 * @class representing the FullStory integration.
 */
export class FullStory {
    /**
     * Creates an instance of FullStory.
     * @param {FullStoryConfig} config - The FullStory configuration.
     */
    constructor(config) {
        this.config = config;
    }
    /**
     * Initializes the FullStory SDK.
     * @private
     */
    init() {
        try {
            initSDK({
                orgId: FullStory.FS_ORG_ID,
                debug: false,
                devMode: this.config.env !== PRODUCTION_ENV,
                recordCrossDomainIFrames: true,
            });
        }
        catch (error) {
            console.error('FullStory init Error: ', error);
        }
    }
    /**
     * Transforms user identity into set identity format.
     * @private
     * @param {UserIdentity} user - The user identity information.
     * @returns {SetIdentity} The transformed user identity.
     */
    transformUserIdentityIntoSetIdentity({ uid, appId, fullName, email, }) {
        return {
            uid,
            properties: {
                appId,
                email,
                displayName: fullName,
            },
        };
    }
    /**
     * Sets user identity in FullStory.
     * @private
     */
    setIdentity() {
        if (this.config.env !== PRODUCTION_ENV) {
            return;
        }
        try {
            FS(FullStory.EVENT_SET_IDENTITY, this.transformUserIdentityIntoSetIdentity(this.config.userIdentity));
        }
        catch (error) {
            console.error('FullStory identifyUser Error: ', error);
        }
    }
    /**
     * Initializes FullStory integration by calling init and setIdentity methods.
     */
    initialize() {
        this.init();
        this.setIdentity();
    }
}
/**
 * FullStory organization ID.
 * @private
 * @type {string}
 */
FullStory.FS_ORG_ID = 'YEK8N';
/**
 * FullStory event name for setting identity.
 * @private
 * @type {string}
 */
FullStory.EVENT_SET_IDENTITY = 'setIdentity';
//# sourceMappingURL=FullStory.js.map